import { propEq } from 'ramda'
import { useSTAYS } from './service/stays/_widget'

export const useWIDGET_CONFIGS = () => {
  const STAYS = useSTAYS()
  return [STAYS]
}

export const useGetWidget = type => {
  const configs = useWIDGET_CONFIGS()
  return configs.find(propEq('id', type))
}
